export default __webpack_public_path__ + "static/media/students_slide.baa2410a.png";